module.exports = __webpack_public_path__ + "media/src/neighbourhood_map/images/ligne17-a0feca33678c5d91a319467258ca976c.png";